import { envConfig } from 'features/environment/services';

const isDevEnvironment = () => envConfig.environment === 'DEVELOP';
const isQaEnvironment = () => envConfig.environment === 'QA';

export const isProductionEnvironment = () =>
  !isDevEnvironment() && !isQaEnvironment();

export const isDevOrQaEnvironment = () =>
  isDevEnvironment() || isQaEnvironment();
